import {configureStore} from "@reduxjs/toolkit";
import {persistReducer, createTransform} from "redux-persist";
import {combineReducers} from "redux";
import storage from "redux-persist/lib/storage";
import appconfigSlice from "./slices/appconfigSlice";
import loginconfigSlice from "./slices/loginconfigSlice";
import searchFilterSlice from "./slices/searchFilterSlice";
import bookingSlice from "./slices/bookingSlice";
import requestSlice from "./slices/requestSlice";
import appTranslationSlice from "./slices/appTranslationSlice";
import chatBotSlice from "./slices/chatBotSlice";

const reducers = combineReducers({
    appconfig: appconfigSlice,
    loginconfig: loginconfigSlice,
    searchfilters: searchFilterSlice,
    booking: bookingSlice,
    chatBotData: chatBotSlice,
    appTranslations: appTranslationSlice,
    requestAPI: requestSlice,
});

// branchData represents the link the user is currently arriving from. It must not
// survive reloads/new link clicks, otherwise an old shared link reappears. Strip it
// out of the persisted appconfig slice (it always rehydrates as null).
const stripBranchData = createTransform(
    (inboundState) => ({...inboundState, branchData: null}),
    (outboundState) => ({...outboundState, branchData: null}),
    {whitelist: ["appconfig"]}
);

const persistConfig = {
    key: "gt-web:rootApp",
    storage,
    whitelist: ["loginconfig", "appconfig", "searchfilters", 'appTranslations'],
    transforms: [stripBranchData],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default store;
